import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import * as Icons from '@seismic/icons';
import { KeyBoardAction } from '../../commonUtil/constants';

Modal.setAppElement(window.document.body);

const CommonDialog = (props) => {
    const setCustomStyles = () => {
        let style = {};
        const customStyles = {
            overlay: {
                backgroundColor: props.backgroundColor,
                zIndex: 10002,
                overflowX: 'auto'
            },
            content: {
                backgroundColor: 'white',
                boxShadow: '0 2px 8px 0 rgba(0,0,0,0.2)',
                border: '0 transparent none',
                borderRadius: '2px',
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                position: 'fixed',
                transform: 'translate(-50%, -50%)',
                width: 'auto',
                height: 'auto'
            }
        };

        if (props.customStyles) {
            style = { overlay: { ...customStyles.overlay, ...props.customStyles.overlay }, content: { ...customStyles.content, ...props.customStyles.content } };
        }

        return style;
    };

    const closeModal = () => {
        props.setIsOpen(false);
    };

    const onCloseKeyDown = (e) => {
        if (e.keyCode === KeyBoardAction.enter) {
            e.preventDefault();
            e.stopPropagation();
            closeModal();
        }
    };

    const customStyles = setCustomStyles();
    const { className, openAnimationClassName, closeAnimationClassName, afterOpenModal, afterCloseModal } = props;
    const modalClassName = `${className} ${props.isOpen ? openAnimationClassName : closeAnimationClassName}`;
    return (
        <Modal
            isOpen={props.isOpen}
            onRequestClose={closeModal}
            shouldCloseOnOverlayClick={props.shouldCloseOnOverlayClick}
            className={modalClassName}
            style={customStyles}
            onAfterOpen={afterOpenModal}
            onAfterClose={afterCloseModal}
            closeTimeoutMS={props.closeTimeoutMS}>
            {props.children}
            {props.showCloseIcon &&
                <div className="common-close-icon"
                    onClick={closeModal}
                    onKeyDown={onCloseKeyDown}
                    tabIndex="0"
                    role="button"
                    aria-label="close modal"
                ><Icons.CloseIcon /></div>}
        </Modal>
    );
};

CommonDialog.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element)
    ]).isRequired,
    shouldCloseOnOverlayClick: PropTypes.bool,
    showCloseIcon: PropTypes.bool,
    className: PropTypes.string,
    backgroundColor: PropTypes.string,
    customStyles: PropTypes.object,
    closeTimeoutMS: PropTypes.number,
    openAnimationClassName: PropTypes.string,
    closeAnimationClassName: PropTypes.string,
    afterCloseModal: PropTypes.func,
    afterOpenModal: PropTypes.func
};

CommonDialog.defaultProps = {
    shouldCloseOnOverlayClick: true,
    showCloseIcon: true,
    className: '',
    customStyles: null,
    backgroundColor: 'rgba(46,48,51,0.6)',
    closeTimeoutMS: 0,
    openAnimationClassName: '',
    closeAnimationClassName: '',
    afterCloseModal: undefined,
    afterOpenModal: undefined
};

export default CommonDialog;
